
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import BtnTools from '../BtnTools/index.vue';
import { IMSDK } from '@/imsdk/index';
const imsdk = IMSDK.create();

interface sourceMsgType {
  uint32_msg_direction: number;
  uint64_time: number;
  bytes_summary: string;
  str_reference_qidian_msg_unique_id: string;
  str_sender_name: string;
}

@Component({
  name: 'ChatTools',
  components: {
    BtnTools,
  },
})
class ChatTools extends Vue {
  @Inject('inIframe') inIframe:boolean|undefined;
  @Inject('globalData') globalData: any;
  @Inject('to') to: any;

  @Prop({
    default: [],
  }) toolButtons: any;

  @Prop({
    default: '',
  }) sourceMsg: sourceMsgType|undefined;

  @Prop({
    default: '',
  }) inputContent: string|undefined;

  @Prop({
    default: false,
  }) bShowTypingSwitch: any;

  @Watch('chatMsg')
  onChatMsgChange(val) {
    this.$emit('update:inputContent', val);
  }

  @Watch('inputContent', { immediate: true })
  onInputContent(val) {
    this.chatMsg = val || '';
  }

  chatMsg = '';
  isCtrlKeyDown = 0;
  textInputStart = 0;

  get isMacOS() {
    return navigator.userAgent.indexOf('mac os');
  }
  get shortcutKey() {
    return this.isMacOS ? 16 : 17;
  }
  formatNickname(dir: number | string): string {
    if (dir === 1 || dir === '访客') {
      return '我';
    }
    return '客服';
  }
  focus() {
    const postElement: any = document.querySelector('.post-area');
    postElement && postElement.focus();
  }
  clickFaceItem(title:string) {
    const postElement:any = this.$el.querySelector('.post-area');
    const startIndex =  postElement.selectionStart || 0;
    this.chatMsg = `${this.chatMsg.substring(0, startIndex)}${title}${this.chatMsg.substring(startIndex, this.chatMsg.length)}`;
    const changeIndex = startIndex + title.length;
    setTimeout(() => {
      postElement.selectionStart = changeIndex;
      postElement.selectionEnd = changeIndex;
      postElement.focus();
    });
  }
  get placeholderMsg() {
    if (/macintosh|mac os x/i.test(navigator.userAgent)) {
      return this.$t('common_postarea_Macpc_placeholder');
    }
    return this.$t('common_postarea_pc_placeholder');
  }

  // 当前接待工号。仅人工(单人/分组)接待有效。机器人接待均返回 0
  get currExtuin() {
    const { extuin } = this.globalData.reception;
    return extuin || 0;
  }

  get toInfo() {
    const toInfo = {
      ...this.to,
      extuin: this.currExtuin,
      user_type: 4,
    };
    return toInfo;
  }

  chatKeyDown(e:any) {
    const chatText:any  = this.$el.querySelector('.post-area');
    if (e.ctrlKey === true || e.metaKey === true) {
      this.isCtrlKeyDown = 1;
    }
    if (e.which === 13 && this.isCtrlKeyDown === 1 && !this.isMacOS) {
      const startIndex =  chatText.selectionStart || 0;
      this.chatMsg = `${this.chatMsg.substring(0, startIndex)}\r\n${this.chatMsg.substring(startIndex, this.chatMsg.length)}`;
      const changeIndex = startIndex  + 1;
      setTimeout(() => {
        chatText.scrollTop = chatText.scrollTop + 20;
        chatText.selectionStart = changeIndex;
        chatText.selectionEnd = changeIndex;
        chatText.focus();
      });
    }
    if (e.which === 13 && this.isCtrlKeyDown === 1 && this.isMacOS) {
      // this.chatMsg = `${this.chatMsg}\r\n`;
      const startIndex =  chatText.selectionStart || 0;
      this.chatMsg = `${this.chatMsg.substring(0, startIndex)}\r\n${this.chatMsg.substring(startIndex, this.chatMsg.length)}`;
      const changeIndex = startIndex  + 1;
      setTimeout(() => {
        chatText.scrollTop = chatText.scrollTop + 20;
        chatText.selectionStart = changeIndex;
        chatText.selectionEnd = changeIndex;
        chatText.focus();
      });
    }
    if (e.which === 13 && this.isCtrlKeyDown === 0) {
      e.preventDefault();
      this.sendMsg();
      // 在回车发送消息之后 上报一次取消输入 因为有的端没有做收到新消息就清除正在输入这条假消息的操作
      // 回车发送消息，输入框没有失去焦点的操作，也就不会上报取消输入 需要在这里特殊处理
      imsdk.sendInputStatusMessage?.(this.toInfo, 2);
    }
  }
  chatKeyUp(e:any) {
    if (e.ctrlKey === false || e.metaKey === false) {
      this.isCtrlKeyDown = 0;
    }
  }
  pasteText(e:any) {
    const clipboardData = (e.clipboardData || e.originalEvent.clipboardData);
    const items  = Array.from(clipboardData.items);
    let includeImg = false;
    const copys:any = [];
    const imgCopys:any = [];
    items.forEach((item:any) => {
      copys.push({
        kind: item.kind,
        type: item.type,
        file: item.getAsFile(),
      });
      if ((item.kind === 'file') && (item.type.match('^image/'))) {
        includeImg = true;
        imgCopys.push(item.getAsFile());
      }
    });

    // 需要判断一下是否开启了发送图片权限
    const btnToolsRef: any = this.$refs.btnTools;
    if (includeImg && btnToolsRef && btnToolsRef.canSendImage) {
      console.log('copys', copys);
      this.$emit('callFunc', 'imageUploadWithCopy', { target: { files: imgCopys } });
      e.preventDefault();
    }
    console.log('pasteText', e, clipboardData, items);
  }

  openFileUpload(type:string) {
    if (type === 'image') {
      this.$emit('callFunc', 'imageUpload');
    } else {
      this.$emit('callFunc', 'fileUpload');
    }
  }
  sendMsg(msg?) {
    if ((!this.chatMsg || !this.chatMsg.trim()) && !msg) {
      this.$Toast('不能发送空白消息');
      return;
    }
    this.$emit('callFunc', 'sendTextMessage', (this.chatMsg || msg));
    this.chatMsg = '';

    this.$nextTick(() => {
      const txtInput: any = this.$refs.textarea;
      txtInput.focus();
      this.textInputStart = 0;
    });
  }

  // 机器人转人工
  robotTransfer() {
    this.$emit('callFunc', 'robotTransfer');
  }

  closeSession() {
    this.$emit('callFunc', 'closeSession');
  }

  /**
   * 退出排队
   */
  exitQueue() {
    this.$emit('callFunc', 'exitQueue');
  }

  // 主动下发满意度
  activeFeedback() {
    this.$emit('callFunc', 'activeFeedback');
  }

  clear() {
    this.chatMsg = '';
    this.$nextTick(() => {
      const txtInput: any = this.$refs.textarea;
      txtInput.focus();
    });
  }

  onInput() {
    const now = Date.now();
    const diff = now - this.textInputStart;
    // 1. 只有在人工接待的场景下才上报输入状态
    // 2. B侧是否展示会话输入状态开关 开启才上报 因为端上在展示的时候不会判断
    // 3. 间隔10s上报一次
    if (this.currExtuin && this.bShowTypingSwitch && diff >= 10 * 1000) {
      this.textInputStart = now;
      imsdk.sendInputStatusMessage?.(this.toInfo, 1);
    }
  }

  onBlur() {
    // 1. 只有在人工接待的场景下才上报输入状态
    // 2. B侧是否展示会话输入状态开关 开启才上报
    if (this.currExtuin && this.bShowTypingSwitch) {
      imsdk.sendInputStatusMessage?.(this.toInfo, 2);
    }
  }
}
export default ChatTools;
